"use strict";

var PropTypes = require('prop-types');

var React = require('react');

function withTranslate(WrappedComponent) {
  function TranslationWrapper(props, context) {
    return React.createElement(WrappedComponent, Object.assign({}, props, {
      isExistingTranslation: context.isExistingTranslation,
      translate: context.translate
    }));
  }

  TranslationWrapper.contextTypes = {
    isExistingTranslation: PropTypes.func,
    translate: PropTypes.func
  };
  return TranslationWrapper;
}

module.exports = {
  withTranslate: withTranslate
};